//import Moment from "moment";

const getCount = (state) => {
	return state.condicoes.length;
}

const getStatusAtualizacaoLista = (state) => {
	if (state.ultimaAtualizacaoLista == null) {
		return true;
	}
	else if(!state.condicoes)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.condicoes.length == 0 ||
			hour - state.ultimaAtualizacaoLista.getHours() > 0
		);
	}
}

export default {
	getCount,
	getStatusAtualizacaoLista
}